import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {replace} from "react-router-redux";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {
    ROUTE_CLUB,
    ROUTE_SECTION, ROUTE_SECTIONS
} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import {confirm} from "../../../utils/confirmDialog";

import SectionGeneral from "./subPages/SectionGeneral";
import SectionContacts from "./subPages/SectionContacts";
import StationSelection from "../../reusable/StationSelection";

class SectionPage extends React.Component {

    static getId() {
        return ROUTE_SECTION;
    }

    static getAllowedRoles() {
        return [UserRoles.CLUB_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        const now = new Date();
        const yrFull = (now.getFullYear() + (now.getMonth() >= 9 ? 1 : 0)).toString();
        this.state = {
            stationMode: 'section'
        }
    }

    componentDidMount() {
        this.loadSection(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.sectionNo !== this.props.params.sectionNo) this.loadSection(nextProps);
    }

    loadSection = newestProps => {
        if (newestProps.params.sectionNo.toLowerCase() !== 'new') {
            newestProps.dispatch(AdminActions.getSection(newestProps.params.sectionNo, () => {this.forceUpdate();}));
        }
    };

    subForm = null;
    fields = [];
    render() {
        // Get club from Redux state.
        const sectionNo = this.props.params.sectionNo;
        const section = sectionNo.toLowerCase() === 'new' || !this.props.admin.sections ? null : this.props.admin.sections.get(sectionNo) || null;
        if (sectionNo.toLowerCase() !== 'new' && (section === null || typeof(section.isFullLoaded) === 'undefined')) return null;
        let subPage = null;

        switch (this.props.params.subpage) {
            case 'general':
                subPage = <SectionGeneral section={section} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;

            case "contacts":
                subPage = <SectionContacts section={section} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;

            case 'clubs':
                subPage = <table className="data-table section-clubs-list">
                    <thead>
                    <tr>
                        <th scope="row">Nr</th>
                        <th>Navn</th>
                        <th>Kommune</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {section === null ? [] : this.props.admin.clubs.filter(club => club.Sektionsnr === sectionNo).sort((m1, m2) => m1.Foreningsnr < m2.Foreningsnr ? -1 : 1).toArray().map(club => {
                        return <tr key={club.Foreningsnr}>
                            <th scope="row">{club.Foreningsnr}</th>
                            <td>{club.Navn}</td>
                            <td>{club.Kommune}</td>
                            <td>
                                <Link to={ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view')} title="Vis detaljer">
                                    <i className="fa fa-file-text-o"/>
                                </Link>
                                <Link to={ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'edit')} title="Rediger medlem">
                                    <i className="fa fa-pencil"/>
                                </Link>
                                <i className={"fa fa-trash pointer"} title="Slet forening" onClick={() => {
                                    confirm("Slet", <span>Ønsker du at slette forening <b>{`${club.Foreningsnr} (${club.Navn})`}</b>?</span>, () => {
                                        this.props.dispatch(AdminActions.deleteClub(club.Foreningsnr, () => {
                                            NotificationManager.success(`Forening ${club.Foreningsnr} (${club.Navn}) er slettet`, "Sletning", 4000);
                                        }));
                                    });
                                }}/>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>;
                break;

            case 'stations':
                subPage = <StationSelection targetId={sectionNo}/>;
                break;
        }

        return (<div>
            <div className="sub-page-title">
                <h2>{sectionNo.toLowerCase() === 'new' ? 'Ny sektion' : 'Sektion ' + sectionNo + ' - ' + section.Navn}</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "general").replace(":mode", "view") : ''}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'contacts' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "contacts").replace(":mode", "view") : ''}>
                        <span className="tab-text">Kontakter</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'clubs' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "clubs").replace(":mode", "view") : ''}>
                        <span className="tab-text">Foreninger</span>
                    </Link>

                    <Link className={(this.props.params.subpage === 'stations' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "stations").replace(":mode", "view") : ''}>
                        <span className="tab-text">Stationsvalg</span>
                    </Link>
                </div>
                <div className="tab-page">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                {this.props.params.mode === 'view' ? [
                    <span className="left-buttons" key="left">
                        {this.props.params.subpage === 'general' || this.props.params.subpage === 'contacts' ? <button className="btn-primary" title="Rediger sektion" disabled={!this.props.auth.isMainAdmin && (!this.props.auth.isClubAdmin || this.props.auth.clubNumber !== sectionNo)} onClick = {() => {
                            this.props.dispatch(replace(ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'edit')));
                        }}>Rediger</button> : null}
                        {this.props.params.subpage === 'clubs' ? <Link className={"btn-primary"} to={ROUTE_CLUB.replace(':clubNo', 'new').replace(':subpage', 'general').replace(':mode', 'create')} title="Opret ny forening">
                            Ny
                        </Link> : null}
                    </span>,
                    <span className="right-buttons" key="right">
                        <Link className="btn-primary" to={ROUTE_SECTIONS} title="Vis alle sektioner">
                            Sektioner
                        </Link>
                    </span>
                ] : [
                    <span className="left-buttons" key="left">
                        <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                            this.subForm.getWrappedInstance().save(sectionNo => {
                                NotificationManager.success(this.props.params.sectionNo.toLowerCase() === 'new' ? "Sektionen er oprettet" : "Sektionen er opdateret.", this.props.params.sectionNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                this.props.dispatch(replace(ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                            })
                        }}>Gem</button>
                    </span>,
                    <span className="right-buttons" key="right">
                        <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                            if (sectionNo.toLowerCase() === 'new') this.props.dispatch(replace(ROUTE_SECTIONS));
                            else this.props.dispatch(replace(ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                        }}>Annuller</button>
                    </span>,
                ]}
            </div>
        </div>);
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };
}

const mapStateToProps = (state) => ({
    auth: {
        isClubAdmin: state.auth.isClubAdmin,
        isMainAdmin: state.auth.isMainAdmin,
    },
    admin: {
        sections: state.admin.sections,
        clubs: state.admin.clubs,
        stations: state.admin.stations,
    }
});

export default connect(mapStateToProps)(SectionPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/section/SectionPage.js